var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"order"},[_c('div',{staticClass:"inner"},[_c('ul',_vm._l((_vm.completedItems),function(item){return _c('li',{key:item.name,staticClass:"item"},[_c('MenuItem',{attrs:{"item":item,"completed":true}})],1)}),0),_c('div',{staticClass:"order-total"},[_vm._v(" Totalt: "+_vm._s(_vm.orderTotal)+" kr ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }